export const backendServer = process.env.REACT_APP_SSR_SERVER || (typeof window != 'undefined' ? window.location.origin : null)